<div class="row" *ngIf="loading">
  <div class="loader">Loading...</div>
</div>

<div class="row mb-3" *ngIf="loaded">

  <div class="col text-right align-self-center">
    <button class="btn btn-default mr-2" (click)="back()">Back</button>
    <button class="btn btn-primary" (click)="save()">Save</button>
  </div>
</div>

<div class="card" *ngIf="loaded">
  <div class="card-header lead font-weight-bold">
    Keyword Detail
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-12">
        <small><i class="text-danger">* indicates mandatory field</i></small>
      </div>
      <div class="col-12 row">
        <dt class="col-2 text-right align-self-center">Source :</dt>
        <dd class="col-4 align-self-center">
           {{keyword.sourceView}}
        </dd>
        <dt class="col-2 text-right">Country :</dt>
        <dd class="col-4 align-self-center">
          <div *ngFor="let country of countryList">
           <span *ngIf="country.code == keyword.country">{{country.name}}</span>
          </div>
        </dd>
        <dt class="col-2 text-right align-self-center">Operator :</dt>
        <dd class="col-4 align-self-center">
           {{keyword.operator}}
        </dd>
        <dt class="col-2 text-right align-self-center">Short Code :</dt>
        <dd class="col-4 align-self-center">
           {{keyword.shortCode}}
        </dd>
        <dt class="col-2 text-right align-self-center">Keyword :</dt>
        <dd class="col-4 align-self-center">
           {{keyword.keyword}}
        </dd>
        <dt class="col-2 text-right align-self-center">Category :</dt>
        <dd class="col-4 align-self-center">
           {{keyword.categoryView}}
        </dd>
        <dt class="col-2 text-right align-self-center">Price :</dt>
        <dd class="col-4">
           <input type="number" [(ngModel)]="keyword.price" placeholder="Price"  class="form-control">
        </dd>
        <dt class="col-2 text-right align-self-center"><span class="text-danger">* </span> Interval :</dt>
        <dd class="col-4">
          <select class="form-control" placeholder="Select" [(ngModel)]="keyword.interval">
            <option *ngFor="let interval of intervalList | keyvalue" [value]="interval.key">{{interval.value}}</option>
          </select>
        </dd>
        <dt class="col-2 text-right align-self-center">
          <i class="fas fa-question-circle" placement="top"></i> &nbsp;<a target="_blank" [routerLink]="['/dashboard/support/schedule']">View usage</a> <br>
          <span class="text-danger">* </span> Schedules :
        </dt>
        <dd class="col-4">
          <input type="text" [(ngModel)]="keyword.schedules" class="form-control" placeholder="Schedules(split by ,)" />
        </dd>
        <dt class="col-2 text-right align-self-center">Content Schedules : </dt>
        <dd class="col-4">
          <input type="text" [(ngModel)]="keyword.contentSchedules" class="form-control" placeholder="Content Schedules(split by ,)" />
        </dd>
        <dt class="col-2 text-right align-self-center"><span class="text-danger">* </span> Min Hour :</dt>
        <dd class="col-4">
          <input type="number" [(ngModel)]="keyword.minHour" class="form-control" placeholder="Min Hour" min="0" max="23" />
        </dd>
        <dt class="col-2 text-right align-self-center"><span class="text-danger">* </span> Max Hour :</dt>
        <dd class="col-4">
          <input type="number" [(ngModel)]="keyword.maxHour" class="form-control" placeholder="Max Hour" min="0" max="23" />
        </dd>
        <dt class="col-2 text-right align-self-center"><span class="text-danger">* </span> With Content When Charge :</dt>
        <dd class="col-4">
          <select class="form-control" placeholder="Select" [(ngModel)]="keyword.mtContentEnabled" placeholder="select" >
            <option value="false">Disabled</option>
            <option value="true">Enabled</option>
          </select>
        </dd>
        <dt class="col-2 text-right align-self-center"><span class="text-danger">* </span> Renewal Enabled :</dt>
        <dd class="col-4">
          <select class="form-control" placeholder="Select" [(ngModel)]="keyword.renewalEnabled" placeholder="select" >
            <option value="false">Disabled</option>
            <option value="true">Enabled</option>
          </select>
        </dd>
        <dt class="col-2 text-right align-self-center"><span class="text-danger">* </span> Broadcast Enabled :</dt>
        <dd class="col-4">
          <select class="form-control" placeholder="Select" [(ngModel)]="keyword.broadcast" placeholder="select" >
            <option value="false">Disabled</option>
            <option value="true">Enabled</option>
          </select>
        </dd>
        <dt class="col-2 text-right align-self-center">Second Keyword :</dt>
        <dd class="col-4">
          <input type="text" [(ngModel)]="keyword.secondKeyword" class="form-control" placeholder="Second Keyword" />
        </dd>
        <dt class="col-2 text-right align-self-center">ServiceId/RecId :</dt>
        <dd class="col-4">
          <input type="text" [(ngModel)]="keyword.productId" class="form-control" placeholder="ServiceId/RecId" />
        </dd>
        <dt class="col-2 text-right align-self-center">Operator ID :</dt>
        <dd class="col-4">
          <input type="text" [(ngModel)]="keyword.operatorId" class="form-control" placeholder="Operator ID" />
        </dd>
        <dt class="col-2 text-right align-self-center">Mobile Country Code :</dt>
        <dd class="col-4">
          <input type="text" [(ngModel)]="keyword.mcc" class="form-control" placeholder="Mobile Country Code" />
        </dd>
        <dt class="col-2 text-right align-self-center">Mobile Network Cod:</dt>
        <dd class="col-4">
          <input type="text" [(ngModel)]="keyword.mnc" class="form-control" placeholder="Mobile Network Cod" />
        </dd>
        <dt class="col-2 text-right align-self-center">Price Tag:</dt>
        <dd class="col-4">
          <input type="text" [(ngModel)]="keyword.priceId" class="form-control" placeholder="Price Tag" />
        </dd>
        <dt class="col-2 text-right align-self-center">TXID Prefix:</dt>
        <dd class="col-4">
          <input type="text" [(ngModel)]="keyword.txPrefix" class="form-control" placeholder="TXID Prefix" />
        </dd>
        <dt class="col-2 text-right align-self-center">Sender ID:</dt>
        <dd class="col-4">
          <input type="text" [(ngModel)]="keyword.senderId" class="form-control" placeholder="Sender ID" />
        </dd>
      </div>
    </div>
  </div>
</div>
